import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FieldArray from "./fieldArray";
import { Popconfirm } from "antd";

export default ({
  mode,
  printMessage,
  id,
  onSubmit,
  handleSubmit,
  getValues,
  errors,
  control,
  register,
  deleteConfigToDB,
  isDuplicatePrintMessageErr
}) => (
    <div>
      <>
        <Card style={{ width: "100%" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <fieldset disabled={mode === "view"}>
                <Row>
                  <Col md={5}>
         
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Print Debug Message
                      </Form.Label>

                      <Form.Control
                        {...register("printMessage")}
                        type="text"
                        isInvalid={errors.printMessage}
                      />

                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "flex" }}
                      >
                        {errors?.printMessage?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  
                    <FieldArray
                      {...{
                        control,
                        register,
                      }}
                      fieldLabel="Terms To Ignore"
                      errors={errors}
                      fieldName="termsToIgnore"
                      addButtonText="Add a new term"
                      property="value"
                    />
                  </Col>
  
                </Row>
                <Row>
                  <Col md={10}>
                    <div style={{ width: "50rem" }}>
                      {mode === "edit" ||
                      mode === "create" ? (
                        <Button
                          variant="primary"
                          type="submit"
                        >
                          {mode === "edit"
                            ? "Update Config"
                            : "Create Config"}
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                    {mode === "create" &&
                    isDuplicatePrintMessageErr ? (
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "flex" }}
                      >
                        print message: "{getValues("printMessage")}{" "}"
                        exists
                      </Form.Control.Feedback>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col md={1}>
                    <div style={{ width: "10rem" }}>
                      {mode === "edit" ? (
                        <Popconfirm
                          title="Sure to delete?"
                          onConfirm={() => {
                            if (deleteConfigToDB) {
                              deleteConfigToDB(id, printMessage);
                            }
                          }}
                        >
                        <Button variant="danger">Delete Config</Button>
                        </Popconfirm>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </fieldset>
            </Form>
          </Card.Body>
        </Card>
      </>
    </div>
);